<template>
  <a-modal title="菜品分配档口" :width="560" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
    <a-form layout="inline" style="margin-bottom:12px">
      <a-input-search v-model="search" placeholder="搜索菜品名称" style="width:260px" @search="loadGoods" enterButton />
    </a-form>
    <a-form-item label="分配到档口" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17, offset: 1 }" style="margin-bottom:12px">
      <a-select v-model="stationId" placeholder="选择档口（选「清除档口」则取消分配）" allow-clear>
        <a-select-option v-for="s in stations" :key="s.id" :value="s.id">{{ s.name }}</a-select-option>
      </a-select>
    </a-form-item>
    <a-table size="small" bordered rowKey="materialId" :rowSelection="{ selectedRowKeys, onChange: onSelect }"
      :columns="columns" :dataSource="goods" :loading="loading" :pagination="false" :scroll="{ y: 320 }">
      <template slot="stationSlot" slot-scope="text">{{ stationName(text) }}</template>
    </a-table>
  </a-modal>
</template>
<script>
import { goodsList, goodsAssignStation } from '@/api/plugin/dining'

export default {
  name: 'DiningGoodsStationModal',
  props: ['stations'],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      loading: false,
      search: '',
      goods: [],
      selectedRowKeys: [],
      stationId: undefined,
      columns: [
        { title: '菜品', dataIndex: 'materialName', width: 200 },
        { title: '当前档口', dataIndex: 'stationId', scopedSlots: { customRender: 'stationSlot' } }
      ]
    }
  },
  methods: {
    show() {
      this.visible = true
      this.search = ''
      this.selectedRowKeys = []
      this.stationId = undefined
      this.loadGoods()
    },
    loadGoods() {
      this.loading = true
      goodsList({ search: this.search, pageSize: 200 }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.goods = (res.data && res.data.rows) || []
        }
      }).catch(() => { this.loading = false })
    },
    stationName(id) {
      const s = this.stations.find(x => x.id === id)
      return s ? s.name : '未分配'
    },
    onSelect(keys) { this.selectedRowKeys = keys },
    handleOk() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先勾选菜品')
        return
      }
      this.confirmLoading = true
      goodsAssignStation({ materialIds: this.selectedRowKeys, stationId: this.stationId || null }).then(res => {
        this.confirmLoading = false
        if (res.code === 200) {
          this.$message.success(res.message || '分配成功')
          this.loadGoods()
          this.selectedRowKeys = []
        } else {
          this.$message.warning(res.message)
        }
      }).catch(() => { this.confirmLoading = false })
    },
    handleCancel() { this.visible = false }
  }
}
</script>
